'use strict';

// The header menus use Bootstrap's Dropdown with Popper, downloaded when a menu toggle is first pointed at,
// focused or touched. A click or arrow key that comes before it has loaded is replayed afterwards.
const TOGGLE = '[data-bs-toggle="dropdown"]';
let loading = null;
let loaded = false;

function load() {
    if (!loading) {
        loading = import(/* webpackChunkName: "dropdown" */ 'bootstrap/js/src/dropdown').then(() => {
            loaded = true;
        }, (error) => {
            // The next pointer, focus or click downloads the file again.
            loading = null;
            throw error;
        });
    }
    return loading;
}

function toggleOf(event) {
    return !loaded && event.target instanceof Element ? event.target.closest(TOGGLE) : null;
}

for (const type of ['mouseover', 'focusin', 'touchstart']) {
    document.addEventListener(type, (event) => toggleOf(event) && load(), { passive: true });
}

document.addEventListener('click', (event) => {
    const toggle = toggleOf(event);
    if (!toggle) return;
    event.preventDefault();
    load().then(() => toggle.click());
});

document.addEventListener('keydown', (event) => {
    const toggle = toggleOf(event);
    if (!toggle || !['ArrowDown', 'ArrowUp'].includes(event.key)) return;
    event.preventDefault();
    load().then(() => toggle.dispatchEvent(new KeyboardEvent('keydown', { key: event.key, bubbles: true, cancelable: true })));
});
